// extracted by mini-css-extract-plugin
module.exports = {"returnToApp":"_1y2nHrpMq12lXAYGKQbtHc","returnToAppHidden":"_1pbQ4VwhBIs0JLD156XGVb","outerWrapper":"JuILTSi83yhQq1nBrn1Du","demoWrapper":"ZehhS-0fVIvgC5UJRmAV2"};